












import Vue from 'vue';
import Grid from '@/packages/ae-grid';
import Component from 'vue-class-component';

Vue.use(Grid);
@Component({
  name: 'Header'
})
export default class Header extends Vue {
}
